__turbopack_context__.v({
  "content": "InscriptionWarningMultiInscriptions-module__1kFzDa__content",
  "inscriptions": "InscriptionWarningMultiInscriptions-module__1kFzDa__inscriptions",
  "title": "InscriptionWarningMultiInscriptions-module__1kFzDa__title",
});
